export default "__VITE_ASSET__CScJRRUn__"